import type { MarketVariants } from '@/lib/i18n'

export type Slide8WrapupCopy = {
  completionTitle: string
  body: string
  buttonLabel: string
}

export const copy: MarketVariants<Slide8WrapupCopy> = {
  US: {
    completionTitle: 'Chapter 2 complete',
    body:
      'Now that you know the scammer’s playbook, the next chapter covers the best way to respond.',
    buttonLabel: 'Start Chapter 3: Pause & Verify',
  },
  ar: {
    completionTitle: 'اكتمل الفصل 2',
    body:
      'الآن وقد عرفت خطة المحتال، يتناول الفصل التالي أفضل طريقة للتصدي له.',
    buttonLabel: 'ابدأ الفصل 3: توقّف وتحقّق',
  },
}
